module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_vm._m(0), _c('div', {
    staticClass: "container moral-uncheck bg04"
  }, [_vm._m(1), _c('div', {
    staticClass: "row inner"
  }, [_c('p', {
    staticClass: "fz14 bold",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_vm._v("今月のモラルチェックをまだ回答されてない方")]), _c('div', {
    staticClass: "user-post-detail__body__others bg05"
  }, _vm._l((_vm.moralNoanswers), function(moral, index) {
    return (_vm.callbackflg) ? _c('div', [(_vm.keybreak(index)) ? _c('div', [_c('span', {
      staticClass: "answer_deadline",
      style: (_vm.first(index))
    }, [_vm._v("回答期限：〜" + _vm._s(moral.attributes['moral-end-date-format']) + "まで")]), _c('div', {
      staticClass: "user-outline"
    }, [(moral.attributes['profile-image-path']) ? _c('div', {
      staticClass: "user-outline__img"
    }, [_c('img', {
      attrs: {
        "src": moral.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    })]) : _c('div', {
      staticClass: "user-outline__img"
    }, [_c('img', {
      attrs: {
        "src": require("../images/img_profile.png"),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "user-outline__body"
    }, [_c('p', {
      staticClass: "user-outline__body__role fz11"
    }, [_vm._v(_vm._s(moral.attributes['shop-name']) + " " + _vm._s(moral.attributes['user-type-name']))]), _c('h3', {
      staticClass: "user-outline__body__name fz16"
    }, [_vm._v(_vm._s(moral.attributes['user-name']) + " " + _vm._s(moral.attributes['user-firstname']))])])])]) : _c('div', [_c('div', {
      staticClass: "user-outline"
    }, [(moral.attributes['profile-image-path']) ? _c('div', {
      staticClass: "user-outline__img"
    }, [_c('img', {
      attrs: {
        "src": moral.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    })]) : _c('div', {
      staticClass: "user-outline__img"
    }, [_c('img', {
      attrs: {
        "src": require("../images/img_profile.png"),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "user-outline__body"
    }, [_c('p', {
      staticClass: "user-outline__body__role fz11"
    }, [_vm._v(_vm._s(moral.attributes['shop-name']) + " " + _vm._s(moral.attributes['user-type-name']))]), _c('h3', {
      staticClass: "user-outline__body__name fz16"
    }, [_vm._v(_vm._s(moral.attributes['user-name']) + " " + _vm._s(moral.attributes['user-firstname']))])])])])]) : _vm._e()
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("戻る")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "moral-uncheck__heading"
  }, [_c('span', {
    staticClass: "brown"
  }, [_vm._v("店舗長の方へ"), _c('br'), _vm._v("お手数ですが"), _c('br'), _vm._v("声かけをお願いしますニャン！            ")])]), _c('p', {
    staticClass: "moral-uncheck__lead bg06 fz15"
  }, [_vm._v("まだ「今月のモラルチェック」が済んでいないスタッフの方には、そっと声かけをお願いいたします。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78570a8b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/moral-noanswer-list.pug
// module id = 1419
// module chunks = 1